import { useState, useEffect } from "react";

type Theme = "light" | "dark";

const STORAGE_KEY = "skyline-theme";

// Module-level listener set — all hook instances share the same state updates
const listeners = new Set<(t: Theme) => void>();

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
    return "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(STORAGE_KEY, theme);
    // Register this instance so other components can push updates to it
    listeners.add(setThemeState);
    return () => { listeners.delete(setThemeState); };
  }, [theme]);

  const toggleTheme = () => {
    const next: Theme = theme === "light" ? "dark" : "light";
    listeners.forEach((cb) => cb(next));
  };

  const setTheme = (t: Theme) => {
    listeners.forEach((cb) => cb(t));
  };

  return { theme, toggleTheme, setTheme };
}
